import axios from 'axios';

const list = (data) => axios.get('/pro/load/list', data);
const save = (data) => axios.post('/pro/load/save', data);
const del = (data) => axios.post('/pro/load/delete', data);


export default {
  list,
  save,
  del,

}


